module.exports = __webpack_public_path__ + "static/media/aerovinum-3.738fb29b.jpg";